export default "__VITE_ASSET__D_prmkd4__"